
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[shortName]/market",
      function () {
        return require("private-next-pages/[shortName]/market.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[shortName]/market"])
      });
    }
  